import React from 'react'
import { Link } from '@/components/Link/Link'
import type {
  CMSComponentResponsiveImage,
  CMSComponentVideo,
  CMSLinkUrl,
} from '@/types/sanity'

type Props = {
  isModuleClickable?: boolean
  moduleUrl?: CMSLinkUrl
  content: {
    image?: CMSComponentResponsiveImage
    video?: CMSComponentVideo
  }
}

export const Wrapper: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  isModuleClickable,
  moduleUrl,
  content,
}) => {
  const isClickable =
    isModuleClickable && moduleUrl && !content?.video?.dialogue

  return isClickable ? (
    <Link link={moduleUrl}>{children}</Link>
  ) : (
    <div>{children}</div>
  )
}
